import React from 'react';
import dynamic from 'next/dynamic';
import AmplienceBreadcrumbs from '../../../components/amplience/breadcrumbs';
import AmplienceContainer from '../../../components/amplience/container';
import AmplienceContentCard from '../../../components/amplience/content-card';
import AmplienceFooter from '../../../components/amplience/footer';
import AmplienceHeadline from '../../../components/amplience/headline';
import AmplienceHeroBanner from '../../../components/amplience/hero-banner';
import AmplienceLayout from '../../../components/amplience/layout';
import AmpliencePage from '../../../components/amplience/page';
import AmplienceSpacer from '../../../components/amplience/spacer';
import AmplienceTabNavigation from '../../../components/amplience/tab-navigation';
import AmplienceIframe from '../iframe';

const AmplienceBannerCarousel = dynamic(() => import('../../../components/amplience/banner-carousel'));
const AmplienceContentCarousel = dynamic(() => import('../../../components/amplience/content-carousel'));
const AmplienceContentCardSlider = dynamic(() => import('../../../components/amplience/content-card-slider'));
const AmplienceImageComponent = dynamic(() => import('../../../components/amplience/image'));
const AmplienceText = dynamic(() => import('../../../components/amplience/text'));
const AmpliencePLPPlaceholder = dynamic(() => import('../../../components/amplience/plp-placeholder'));
const AmplienceBlogTags = dynamic(() => import('../blog-tags'));
const AmplienceIframePlaceholder = dynamic(() => import('../iframe-placeholder'));
const AmplienceTrackableForm = dynamic(() => import('../trackable-form'));
const AmpliencePLPBreadcrumbPlaceholder = dynamic(
  () => import('../../../components/amplience/plp-breadcrumb-placeholder'),
);
const AmplienceRecentlyViewedPlaceholder = dynamic(() => import('../recently-viewed-placeholder'));
const AmplienceSocialShare = dynamic(() => import('../social-share'));
const AmplienceAccordion = dynamic(() => import('../accordion'));
const AmplienceSeoFooter = dynamic(() => import('../seo-footer'));

const AmplienceDynamicComponent = ({ data, ...props }: any) => {
  const schema = data?.['_meta']?.schema?.split('/')?.pop();
  const componentData = { ...data, ...props };

  switch (schema) {
    case 'page-slot':
    case 'page':
      return <AmpliencePage {...componentData} />;
    case 'content-card':
      return <AmplienceContentCard {...componentData} />;
    case 'layout-2-column':
      return <AmplienceLayout numberOfColumns={2} {...componentData} />;
    case 'layout-3-column':
      return <AmplienceLayout numberOfColumns={3} {...componentData} />;
    case 'layout-4-column':
      return <AmplienceLayout numberOfColumns={4} {...data} />;
    case 'container':
      return <AmplienceContainer {...data} />;
    case 'hero-banner':
      return <AmplienceHeroBanner {...componentData} />;
    case 'headline':
      return <AmplienceHeadline {...componentData} />;
    case 'spacer':
      return <AmplienceSpacer {...componentData} />;
    case 'footer':
      return <AmplienceFooter {...componentData} />;
    case 'banner-carousel':
      return <AmplienceBannerCarousel {...componentData} />;
    case 'content-carousel':
      return <AmplienceContentCarousel {...componentData} />;
    case 'content-card-slider':
      return <AmplienceContentCardSlider {...componentData} />;
    case 'image':
      return <AmplienceImageComponent {...data} />;
    case 'breadcrumbs':
      return <AmplienceBreadcrumbs {...componentData} />;
    case 'text':
      return <AmplienceText {...componentData} />;
    case 'plp-placeholder':
      return <AmpliencePLPPlaceholder {...componentData} />;
    case 'trackeable-form':
      // trackeable-form spelling to match the amplience schema ID (renaming would require migrating all existing entries)
      return <AmplienceTrackableForm {...data} />;
    case 'plp-breadcrumb-placeholder':
      return <AmpliencePLPBreadcrumbPlaceholder {...componentData} />;
    case 'blog-tags':
      return <AmplienceBlogTags {...data} />;
    case 'tab-navigation':
      return <AmplienceTabNavigation {...data} />;
    case 'iframe-placeholder':
      return <AmplienceIframePlaceholder {...componentData} />;
    case 'iframe':
      return <AmplienceIframe {...componentData} />;
    case 'recently-viewed-placeholder':
      return <AmplienceRecentlyViewedPlaceholder {...data} />;
    case 'social-share':
      return <AmplienceSocialShare {...data} />;
    case 'accordion':
      return <AmplienceAccordion {...componentData} />;
    case 'seo-footer':
      return <AmplienceSeoFooter {...componentData} />;
    default:
      return null;
  }
};

export default AmplienceDynamicComponent;
